import { render, staticRenderFns } from "./MasterButtom.vue?vue&type=template&id=36b543ea&scoped=true&"
import script from "./MasterButtom.vue?vue&type=script&lang=js&"
export * from "./MasterButtom.vue?vue&type=script&lang=js&"
import style0 from "./MasterButtom.vue?vue&type=style&index=0&id=36b543ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b543ea",
  null
  
)

export default component.exports